import React, { Suspense, lazy } from 'react'
import { Modal } from '@web/walter-ui-kit'
import Preloader from './Preloader'
import { useModal } from '~contexts/ModalsContext'
import { ModalTypes } from '~contexts/ModalsContext/types'

const Content = lazy(() => import('./Content'))

function ReferralModal() {
    const { isOpen, hide } = useModal(ModalTypes.referral)

    return (
        <Modal
            size="s"
            type="dialog"
            onClose={hide}
            isOpen={isOpen}
            withHeaderBorder={false}
            dataPointer="referral_modal"
        >
            <Suspense fallback={<Preloader />}>
                <Content />
            </Suspense>
        </Modal>
    )
}

export default ReferralModal
